import { Select as AntdSelect } from "antd";
import { Field, FieldInputProps, FieldMetaProps, FormikProps } from "formik";

import { Styles } from "./styled";

const { Option } = AntdSelect;

const Select = (props: any) => {
  // eslint-disable-next-line react/prop-types
  const { name, label, required, options, ...rest } = props;
  return (
    <Styles>
      <Field name={name}>
        {({
          field,
          meta,
          form,
        }: {
          field: FieldInputProps<string>;
          meta: FieldMetaProps<string>;
          form: FormikProps<string>;
        }) => {
          return (
            <div className="field-section">
              {label ? (
                <label>
                  {label}
                  {required ? <span>*</span> : null}
                </label>
              ) : null}
              <AntdSelect
                className={`${meta.error ? "is-error" : ""}`}
                {...field}
                onChange={(value) => {
                  form.setFieldValue(name, value);
                }}
                {...rest}
              >
                {/* eslint-disable-next-line react/prop-types */}
                {options?.map((item: { value: any; label: string }) => (
                  <Option key={item.value} value={item.value}>
                    {item.label}
                  </Option>
                ))}
              </AntdSelect>
            </div>
          );
        }}
      </Field>
    </Styles>
  );
};

export default Select;
